import type { WebSocketMessage } from '../types'
import { socketIOService } from './websocket-socketio';

/**
 * WebSocket service that delegates to Socket.IO implementation
 * This provides better resilience against Chrome's offline detection bug
 */
export class WebSocketService {
  connect(): Promise<void> {
    return socketIOService.connect();
  }

  send(message: WebSocketMessage): void {
    socketIOService.send(message);
  }

  subscribe(event: string, handler: (data: any) => void): () => void {
    return socketIOService.subscribe(event, handler);
  }

  disconnect(): void {
    socketIOService.disconnect();
  }

  isConnected(): boolean {
    return socketIOService.isConnected();
  }

  joinRoom(room: string): void {
    socketIOService.joinRoom(room);
  }

  leaveRoom(room: string): void {
    socketIOService.leaveRoom(room);
  }

  getStats(): {
    connected: boolean;
    reconnectAttempts: number;
    queuedMessages: number;
    activeSubscriptions: number;
  } {
    return socketIOService.getStats();
  }
}

// Export singleton instance
export const wsService = new WebSocketService();